import _isPlainObject from "lodash/isPlainObject";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var isActionCreator = function isActionCreator(obj) {
  return !!(typeof obj === 'function' && obj.TYPE && obj.TYPE === obj.toString());
};
export var getOptions = function getOptions(_ref) {
  var userArgsMapper = _ref.argsMapper,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$defaultOptions = _ref.defaultOptions,
      defaultOptions = _ref$defaultOptions === void 0 ? {} : _ref$defaultOptions;

  if (_isPlainObject(userArgsMapper)) {
    return _objectSpread(_objectSpread({}, defaultOptions), userArgsMapper);
  } else {
    var argsMapper = userArgsMapper || options.argsMapper || defaultOptions.argsMapper;
    return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), argsMapper ? {
      argsMapper: argsMapper
    } : {});
  }
};